<section *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" novalidate [formGroup]="formUpdateCostCenterPrice">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
              <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
            </div>

            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                (onClick)="deleteUpdateCostCenterPrice()"></app-custom-button>

              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewRegister()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-12">
            <div class="row">
              <div class="col-lg-3 col-md-4 col-sm-4 col-12">
                <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                  [required]="true" [recovery]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-12">
                <app-custom-input-number formControlName="consecutive" [labelText]="'Código'" [required]="true"
                  [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
              </div>
              <div class="col-lg-1 col-md-2 col-sm-2 col-12">
                <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateUpdateCostCenterPrice">
                </app-custom-tag>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-5 col-md-6 col-sm-6 col-12">
                <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                  [rows]="1" [maxLength]="250"></app-custom-textarea>
              </div>
              <div class="col-lg-2 col-md-1 col-1 d-flex gap-1 align-items-end mt-1">
                <app-custom-button [title]="'Procesar'" [label]="'Procesar'" [severity]="'primary'"
                  [disabled]="disableProcessButton" (onClick)="processUpdateCostCenterPrice()">
                </app-custom-button>
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                  [disabled]="disableSendButton" (onClick)="send()">
                </app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-update-cost-center-price-detail [updateCostCenterPriceModel]="updateCostCenterPriceContract"
      [disabledDetail]="disabledForm" (emitQuantityDetails)="quantityDetails = $event; updateFormState()">
    </app-update-cost-center-price-detail>
  </div>
</section>

<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>